export type PresetId = 'short' | 'long' | 'special';

const SHORT: Record<string, string> = {
  PATIENT: 'Bär Jörg',
  PATIENTDOB: '12.03.1985',
  PATIENTAISID: '4711',
  SVNR: '1234120385',
  DOCTOR: 'Dr. Grün Käthe',
  DOCTORID: '1001',
  TEXT: 'EDTA',
  TEXT2: 'Blutbild',
  LOCATION: 'Vene',
  BARCODE: '12345678',
  ID: '3f2b6c1e-8d4a-4c7b-9e2f-1a5d7c9b0e34',
  RUNID: '1',
  PRETTYCODE: '1234 5678',
  LAB: 'LAB',
  FEATURES: 'Kühlen',
  STATIONS: 'HÄM',
  INSURANCE: 'ÖGK',
  ACUTE: '',
};

/** Barcode values are digits with an even count, so ^BC subset C and ^B2 render real barcodes. */
export const LABEL_PRESETS: { id: PresetId; label: string; values: Record<string, string> }[] = [
  { id: 'short', label: 'Kurz', values: SHORT },
  {
    id: 'long',
    label: 'Lang',
    values: {
      ...SHORT,
      PATIENT: 'Mag. Müller-Lüdenscheid Jürgen-Österreicher',
      PATIENTDOB: '29.02.1944',
      PATIENTAISID: 'AIS-2026-000123456',
      SVNR: '1237290244',
      DOCTOR: 'Univ.-Prof. Dr. Größinger-Wöß Käthe MSc',
      DOCTORID: '987654',
      TEXT: 'Serum-Gel',
      TEXT2: 'Gerinnung/Hämostase',
      LOCATION: 'Wundabstrich li. Unterschenkel',
      BARCODE: '9876543210',
      RUNID: '12',
      PRETTYCODE: '98 765 432 10',
      FEATURES: 'Lichtgeschützt, Kühlen, Sofort zentrifugieren',
      STATIONS: 'HÄM+CHE+IMM+GER',
      INSURANCE: 'BVAEB-EB',
    },
  },
  {
    id: 'special',
    label: 'Sonderzeichen',
    values: {
      ...SHORT,
      PATIENT: 'Ščerbáková-Yılmaz Zażółć',
      DOCTOR: 'Dr. Kovačević Miloš',
      LOCATION: 'Øresund-Straße',
    },
  },
];
